import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "closeButton"]

  connect() {
    this.previouslyFocusedElement = document.activeElement
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
    document.body.classList.add("overflow-hidden")

    requestAnimationFrame(() => {
      this.panelTarget.classList.remove("translate-x-full")
      this.closeButtonTarget.focus()
    })
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.isClosing) return

    this.isClosing = true
    this.panelTarget.classList.add("translate-x-full")
    window.setTimeout(() => {
      this.element.removeAttribute("data-controller")
      this.element.replaceChildren()
      this.previouslyFocusedElement?.focus()
    }, 300)
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
